<div class="h-full flex flex-col justify-center">
  <div class="w-full h-full flex">
    <div class="border m-auto p-3 flex" style="max-height: 75vh; max-width: 75vw;">
      <app-admin-stock-closures></app-admin-stock-closures>
      <!-- <form [formGroup]="form">
        <dx-date-box formControlName="time" type="time" />
      </form> -->
    </div>
  </div>
</div>
